<template lang="pug">
.main_container(v-if="getUser.group == 3 || getUser.group == 4 || this.$route.query.t")
  .information_systems
    .logo
      img(src="../../assets/wmlogo.png")
    .product_text Webiomed
  .right(style="text-align: right; display:grid; justify-content: right")
    .out(@click="logout" title="Выход из системы")
      //- img.icon(src="../../assets/png/logout.png")
      span Выход
.main_container(v-else)
  .left(@click="$router.push({name: 'Main'})")
    .logo
      img(src="../../assets/wmlogo.png")
  .navigation
    .product_link(title="Перейти на главную страницу" @click="$router.push({name: 'Main'})") Webiomed
    .breadcrumbs(v-if="breadcrumbs" v-for="b in breadcrumbs")
      .item_block
        .arrow →
        router-link.item(:to = "{name: b.state, params: b.params, query: b.query}") {{b.title}}
    .caption(v-if="caption")
      .arrow →
      .text {{caption}}
  .right
    .user
      router-link(:to="{name: 'UserSummary', params: {id: getUser.id, prevState: 'Heading'}}")
        //- img.icon(src="../../assets/png/user.png")
        span {{getUser.last_name}} {{getUser.first_name}}
      .userUnicData
        label.user__title {{getUser.last_name}}&nbsp;{{getUser.first_name}}
        br
        label <b>Имя учётной записи:</b> {{getUser.username || '—'}}
        </br>
        label <b>Название МО:</b> {{getUser.hospital_name || '—'}}
        </br>
        label <b>Регион:</b> {{getUser.region_name || '—'}}
    .out(@click="logout" title="Выход из системы")
      //- img.icon(src="../../assets/png/logout.png")
      span Выход
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    'v-icon': Icon
  },
  data: () => ({}),
  props: ['breadcrumbs', 'caption'],
  computed: mapGetters(['getUser']),
  methods: {
    logout () {
      this.$store.dispatch('deauthorize').then(this.$router.push('/login'))
    }
  }
}
</script>

<style lang="sass" scoped>
.main_container
  display: grid
  grid-template-columns: auto 1fr auto
  align-content: center
  position: fixed
  left: 0
  right: 0
  z-index: 10000
  color: white
  background: url('../../assets/bg.jpg')
  background-size: cover
  height: 55px
  padding: 0 60px
  font-size: 17px
.main_container a
  color: white
  text-decoration: none

// LEFT
.information_systems
  display: grid
  grid-template-columns: auto 1fr
  grid-gap: 10px
  font-weight: 450
.logo
  display: grid
  align-content: center
  cursor: pointer
.logo img
  width: 25px
.information_systems .logo
  cursor: default
.product_text
  display: flex
  margin-top: 5px

//NAVIGATION
.navigation
  display: flex
  flex-direction: row
  flex-wrap: wrap
  align-content: center
.product_link
  margin-left: 10px
  font-weight: 450
  cursor: pointer
  border-bottom: 1px solid white
.product_link:hover
  color: #d9d9d9
.caption
  display: flex
.breadcrumbs
  display: flex
.item_block
  display: flex
.item
  border-bottom: solid white 1px
.item:hover
  color: #d9d9d9
.arrow
  margin: 0 6px 0 6px

// RIGHT
.right
  display: flex
  flex-wrap: wrap
  align-content: center
.user
  margin-right: 25px
.out
  cursor: pointer
.out:hover
  color: #d9d9d9
.icon
  margin-right: 10px

.user
  visibility: hidden

.user span
  visibility: visible

.user:hover
  visibility: visible

.user div
  color: #000
  position: fixed
  z-index: 10
  top: 0
  bottom: 69%
  right: 20px
  margin: auto
  box-shadow: 0 0 20px #000, 0 0 0 10000px rgba(210, 210, 210, .1)

.userUnicData
  min-width: 240px
  max-width: 500px
  height: 145px
  padding: 10px 20px
  border-radius: 40px
  background: #ebf7f9
  font-size: 15px
  margin: 0

.userUnicData b
  font-size: 16px
.userUnicData label
  margin: 0
.user__title
  padding-bottom: 10px
  font-size: 22px
  font-weight: 600

@media screen and (max-width: 1620px)
  .main_container
    font-size: 15px
@media screen and (max-width: 1460px)
  .main_container
    font-size: 14px
    padding: 0 20px
</style>
